module.exports = __webpack_public_path__ + "src/assets/img/polls.ae1c2294.jpg";